import {createContext} from 'react';


export const AppContext = createContext({
    data:undefined,setData:undefined,
    status:undefined,setStatus:undefined,
    session:undefined,setSession:undefined,
    splitPaneEnabled:undefined, setSplitPaneEnabled:undefined,
    entities:undefined,setEntities:undefined});